import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeLayers,
  FontAwesomeLayersText,
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import {
  faArrowLeftLong as freeFasFaArrowLeftLong,
  faArrowRightLong as freeFasFaArrowRightLong,
  faMagnifyingGlass as freeFasFaMagnifyingGlass
} from '@fortawesome/free-solid-svg-icons'

import {
  faTwitter as freeFabFaTwitter,
  faLinkedinIn as freeFabFaLinkedinIn,
  faXTwitter as freeFabFaXTwitter,
  faBluesky as freeFabFaBluesky
} from '@fortawesome/free-brands-svg-icons'

library.add(
  freeFasFaArrowLeftLong,
  freeFasFaArrowRightLong,
  freeFasFaMagnifyingGlass,
  freeFabFaTwitter,
  freeFabFaLinkedinIn,
  freeFabFaXTwitter,
  freeFabFaBluesky
)

config.autoAddCss = false

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.component('FontAwesomeLayers', FontAwesomeLayers)
Vue.component('FontAwesomeLayersText', FontAwesomeLayersText)
